import { useRef } from "react";
import { useParams } from "react-router-dom";
import { formatShortDate, useApi } from "@/lib/api";
import { RichContent } from "@/components/site/RichContent";
import { ShareMenu } from "@/components/site/ShareMenu";
import { BackLink, DetailSkeleton, NotFound } from "@/components/site/DetailBits";
import { ReadingProgress } from "@/components/site/ReadingProgress";
import { RelatedArticles } from "@/components/site/RelatedArticles";

const CONF = {
  news: { api: "/news", back: "/news", label: "Retour au magazine", kicker: "Magazine" },
  podcasts: { api: "/podcasts", back: "/radio#podcasts", label: "Retour à la radio", kicker: "Podcast" },
};

export default function ArticleDetail({ kind }) {
  const { slug } = useParams();
  const c = CONF[kind];
  const ref = useRef(null);
  const { data: a, isLoading, isError } = useApi(`${c.api}/${slug}`);
  if (isLoading) return <DetailSkeleton />;
  if (isError || !a) return <NotFound to={c.back} label={c.label} />;

  return (
    <article className="pt-32 pb-32" data-testid={`${kind}-detail`}>
      <ReadingProgress targetRef={ref} />
      <div className="max-w-[1100px] mx-auto px-5 md:px-10">
        <BackLink to={c.back} label={c.label} />
        <p className="text-sm font-bold uppercase tracking-[0.2em] text-primary mt-10">{c.kicker} · {formatShortDate(a.date)}</p>
        <h1 className="font-display uppercase text-4xl sm:text-5xl lg:text-7xl leading-[0.95] text-white mt-3 break-words reveal" data-testid={`${kind}-detail-title`}>{a.title}</h1>
        <div className="mt-8">
          <ShareMenu text={a.title} testId={`${kind}-share`} label="Partager"
            className="border border-white/30 text-white uppercase text-xs font-bold tracking-[0.2em] px-5 py-3 hover:border-white" />
        </div>
        {a.image && (
          <div className="mt-12 overflow-hidden bg-[hsl(var(--surface))] max-w-[760px]">
            <img src={a.image} alt={a.title} className="w-full h-auto reveal" />
          </div>
        )}
        <div ref={ref} className="mt-12 max-w-[760px]">
          <RichContent content={a.content} fallback={a.excerpt} embeds={a.embeds} />
        </div>
        {kind === "news" && <RelatedArticles article={a} />}
      </div>
    </article>
  );
}
